<template>
  <div>
    <h2 class="text-center">{{ $route.meta.title }}</h2>
    <el-container>
      <el-header height="auto" class="header-container">
        <el-row :gutter="20">
          <el-col :span="19">
            <div class="utility-section">
              <el-row>
                <router-link :to="{ name: 'newLongTermOrder' }">
                  <el-button type="success">+ 預約長照單</el-button>
                </router-link>
                <router-link :to="{ name: 'makeupLongTermOrder' }">
                  <el-button type="success">補長照單</el-button>
                </router-link>
                <el-button type="warning" @click="downloadDialog">
                  下載資料
                </el-button>
              </el-row>

              <el-form
                ref="searchFilter"
                :inline="true"
                :model="filter"
                label-width="8em"
                style="margin-top: 15px"
              >
                <el-row>
                  <el-col :span="24">
                    <el-radio-group
                      v-model="filter.order_status"
                      @input="searchOrders()"
                    >
                      <el-radio-button
                        v-for="o in defaultOption.orderStatusOptions"
                        :key="o.value"
                        :label="o.value"
                      >
                        {{ o.label }}
                      </el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>

                <h4>進階搜尋</h4>

                <!--                <el-row>-->
                <!--                  <el-col :span="12">-->
                <!--                    <el-input placeholder="輸入關鍵字" @input="searchOrders()" v-model="filter.keyword"></el-input>-->
                <!--                  </el-col>-->
                <!--                </el-row>-->

                <el-row>
                  <el-col :span="24">
                    <el-form-item label="預定時間">
                      <el-date-picker
                        v-model="filter.start_date"
                        type="date"
                        placeholder="開始時間"
                      ></el-date-picker>
                      <el-date-picker
                        v-model="filter.end_date"
                        type="date"
                        placeholder="結束時間"
                      ></el-date-picker>
                      <!-- <el-date-picker v-model="filter.start_date" type="datetime" placeholder="開始時間"></el-date-picker> -
                      <el-date-picker v-model="filter.end_date" type="datetime" placeholder="結束時間"></el-date-picker> -->
                    </el-form-item>
                    <el-radio-group
                      v-model="datetimeRangeType"
                      @change="
                        $set(filter, 'start_date', $event.start_date)
                        $set(filter, 'end_date', $event.end_date)
                        searchOrders()
                      "
                    >
                      <el-radio-button
                        v-for="o in datetimeRangeTypeOptions"
                        :key="o.label"
                        :label="o.value"
                      >
                        {{ o.label }}
                      </el-radio-button>
                    </el-radio-group>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col>
                    <el-form-item label="乘客姓名">
                      <el-input v-model="filter.user_name" clearable></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item label="司機姓名">
                      <el-input
                        v-model="filter.driver_name"
                        clearable
                      ></el-input>
                    </el-form-item>
                    <el-button
                      type="primary"
                      round
                      plain
                      @click="searchOrders()"
                    >
                      搜尋
                    </el-button>
                    <el-button
                      type="danger"
                      round
                      plain
                      @click="(resetFilter(), searchOrders())"
                    >
                      清除搜尋條件
                    </el-button>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-col>

          <el-col :span="5">
            <div class="stat-section">
              <StatCard
                title="今日載客狀況"
                color="#18A55D"
                :stat="totalData"
                @refresh="getTotalData"
              />
              <StatCard
                title="明日派車狀況"
                color="#00C0EF"
                :stat="tomorrowData"
                @refresh="getTotalData"
                style="margin-top: 20px"
              />
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <el-select
          v-model="paging.perPage"
          size="small"
          @change="searchOrders()"
          class="d-inline-block"
          style="margin-bottom: 20px"
          placeholder="選擇"
        >
          <el-option
            v-for="item in defaultOption.perPageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <DriverAwaitStatusOrderList
          v-if="filter.order_status === '0'"
          :orders="queryResult"
          @reload="searchOrders"
        />
        <VerifyAwaitStatusOrderList
          v-else-if="filter.order_status === '3'"
          :orders="queryResult"
          @reload="searchOrders"
        />
        <NormalOrderList v-else :orders="queryResult" />
        <DownloadLongCareDialog
          ref="downloadLongCareDialog"
          :driverList="[]"
        ></DownloadLongCareDialog>
      </el-main>
      <el-footer style="text-align: right">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-count="paging.totalPages || 1"
          :page-size="paging.perPage"
          :current-page.sync="paging.currentPage"
          :total="paging.totalEntries"
          class="d-inline-block"
          @current-change="searchOrders"
          @size-change="searchOrders"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
const log = console.log
import _ from 'lodash'
import moment from 'moment'
import { defaultOption } from './defaultOption'
import longTermCareService from '@/API/longTermCareService'
import NormalOrderList from './_NormalOrderList'
import DriverAwaitStatusOrderList from './_DriverAwaitStatusOrderList'
import VerifyAwaitStatusOrderList from './_VerifyAwaitStatusOrderList'
import StatCard from './StatCard'
import DownloadLongCareDialog from '../../components/element_ui/DownloadLongCareDialog'

const today = () => moment()
const tomorrow = () => moment().add(1, 'day')
const yesterday = () => moment().subtract(1, 'day')
const datetimeRangeTypeOptions = [
  { label: '全部', value: { start_date: null, end_date: null } },
  {
    label: '今日',
    value: {
      start_date: today().startOf('day'),
      end_date: today().endOf('day'),
    },
  },
  {
    label: '明日',
    value: {
      start_date: tomorrow().startOf('day'),
      end_date: tomorrow().endOf('day'),
    },
  },
  {
    label: '昨日',
    value: {
      start_date: yesterday().startOf('day'),
      end_date: yesterday().endOf('day'),
    },
  },
  {
    label: '本月',
    value: {
      start_date: today().startOf('month'),
      end_date: today().endOf('month'),
    },
  },
]
export default {
  components: {
    NormalOrderList,
    DriverAwaitStatusOrderList,
    VerifyAwaitStatusOrderList,
    StatCard,
    DownloadLongCareDialog,
  },
  data() {
    const parseQuery = (query) => {
      const {
        order_status = 6,
        start_date,
        end_date,
        keyword,
        user_name,
        driver_name,
        per_page,
        current_page,
      } = query

      return {
        filter: {
          order_status,
          start_date,
          end_date,
          keyword,
          user_name,
          driver_name,
        },
        paging: {
          perPage: (per_page && Number(per_page)) || 25,
          currentPage: (current_page && Number(current_page)) || 1,
        },
      }
    }

    const initial = parseQuery(this.$route.query)

    return {
      defaultOption,
      filter: {
        ...initial.filter,
      },
      queryResult: [],
      paging: {
        ...initial.paging,
      },
      datetimeRangeType: { start_date: null, end_date: null },
      datetimeRangeTypeOptions,
      initial,
      totalData: {
        achievementRate: '0.00%',
        loadFactor: null,
        total: 0,
        waitForDriver: 0,
        waitForSubmit: 0,
      },
      tomorrowData: {
        achievementRate: '0.00%',
        loadFactor: null,
        total: 0,
        waitForDriver: 0,
        waitForSubmit: 0,
      },
    }
  },
  created() {
    this.searchOrders()
    this.getTotalData()
  },
  methods: {
    downloadDialog() {
      this.$refs.downloadLongCareDialog.openDialog()
    },
    getTotalData() {
      longTermCareService.getOrderTotal().then((raw) => {
        console.log(raw.result)
        this.totalData = raw.result.today
        this.tomorrowData = raw.result.tomorrow
      })
    },
    resetFilter() {
      const filter = {}
      this.$set(this, 'filter', filter)
    },
    searchOrders() {
      this.getTotalData()
      const {
        filter,
        paging: { currentPage: current_page = 1, perPage: per_page = 25 },
      } = this

      this.$router.replace({
        name: 'longTermOrderList',
        query: { ...filter, per_page, current_page },
      })

      // FIXME: 後端不吃 ISO Format，暫時手動 parse
      filter.start_date = filter.start_date
        ? this.$moment(filter.start_date).format('YYYY-MM-DD')
        : null
      filter.end_date = filter.end_date
        ? this.$moment(filter.end_date).format('YYYY-MM-DD')
        : null
      return longTermCareService
        .queryOrders({ ...filter, current_page, per_page })
        .then((data) => {
          log('query result', data)
          if (data.result) {
            data.result.data = _.map(data.result.data, (item) => {
              return {
                ...item,
                driver: item.driverName
                  ? {
                      callNumber: item.callNumber || '呼號',
                      id: item.driverId,
                      licenseNumber: item.licenseNumber || '車牌',
                      name: item.driverName,
                    }
                  : null,
              }
            })
          }
          return data.result
        })
        .then(({ data, paging }) => {
          this.queryResult =
            _.orderBy(
              data,
              (d) => {
                const [hour = 0, minute = 0] = d.estimateTime.split(':')
                return moment(d.estimateDate).hour(hour).minutes(minute).unix()
              },
              ['desc'],
            ) || []

          this.paging = paging || {}
        })
    },
  },
}
</script>

<style scoped>
.el-header.header-container {
  padding: 0 20px;
  background: #ecf0f5;
}

.utility-section {
  background: white;
  padding: 20px;
}

.stat-section {
  position: relative;
  flex-direction: column;
  justify-content: space-between;
}

.d-inline-block {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/OrderList.vue